// src/environments/environment.ts  **** Configuração da produção****

/*export const environment = {
  production: false,
   url: 'https://api.trocadatas.com',
  recaptchaSiteKey: '6Lclhe4qAAAAABTzF4TMMJYxd_m-cTLxipJMZyge',
  firebaseConfig: {
    apiKey: "AIzaSyDeN-nzSaFGXZPKSE18DfXPjhrjRPsjY_Q", 
    authDomain: "troca-datas.firebaseapp.com",
    databaseURL: "https://troca-datas-default-rtdb.firebaseio.com",
    projectId: "troca-datas",
    storageBucket: "troca-datas.appspot.com",
    messagingSenderId: "433965504734",
    appId: "1:433965504734:web:7bd5ffa0abc963875aca4f",
    measurementId: "G-SNN944BNDM"
  }
};*/


// src/environments/environment.ts homologação!
export const environment = {
  production: false,
    //url: 'http://localhost:8443',
    url: 'https://homolog.trocadatas.com',
  recaptchaSiteKey: '6Lclhe4qAAAAABTzF4TMMJYxd_m-cTLxipJMZyge',
  firebaseConfig: {
    apiKey: "AIzaSyDne-3zipR8G0iW5IwK7W9I2MEDiNGXFts",
    authDomain: "homologacao-6e12a.firebaseapp.com",
    projectId: "homologacao-6e12a",
    storageBucket: "homologacao-6e12a.firebasestorage.app",
    messagingSenderId: "419199672325",
    appId: "1:419199672325:web:66dc518cab82a2d0c1bc6c"
  }
};